var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.975 5.99167V11.1417H2.16667V5.99167C2.16667 4.06667 3.73333 2.5 5.65833 2.5H14.4833C16.4083 2.5 17.975 4.06667 17.975 5.99167Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 11.1396V11.298C2.16667 13.2313 3.73333 14.7896 5.65833 14.7896H8.65833C9.11667 14.7896 9.49167 15.1646 9.49167 15.623V16.3063C9.49167 16.7646 9.11667 17.1396 8.65833 17.1396H6.775C6.45 17.1396 6.18333 17.4063 6.18333 17.7313C6.18333 18.0563 6.45 18.323 6.775 18.323H13.3833C13.7083 18.323 13.975 18.0563 13.975 17.7313C13.975 17.4063 13.7083 17.1396 13.3833 17.1396H11.5083C11.05 17.1396 10.675 16.7646 10.675 16.3063V15.623C10.675 15.1646 11.05 14.7896 11.5083 14.7896H14.4833C16.4167 14.7896 17.975 13.223 17.975 11.298V11.1396H2.16667Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.825 1.96928L17.8833 2.62761V2.27761C17.8833 1.48595 17.2417 0.852613 16.4583 0.852613H12.8917C12.0333 0.844279 11.3333 1.54428 11.3333 2.40261V5.13595C11.3333 5.85261 11.6917 6.56095 12.7583 6.56095H16.45C17.2417 6.56095 17.875 5.91928 17.875 5.13595V4.77761L18.8167 5.43595C19.2917 5.76095 19.6667 5.56095 19.6667 4.99428V2.41095C19.6667 1.84428 19.2917 1.65261 18.825 1.96928Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon01);
export default __webpack_public_path__ + "static/media/call-icon-01.9d0f9b39d7d09bf151d7cfd688626ca0.svg";
export { ForwardRef as ReactComponent };